module.exports = __webpack_public_path__ + "img/Slavia-Prague.655ca939.png";